export function isDST(date = new Date()) {
    const january = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
    const july = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();

    return Math.max(january, july) !== date.getTimezoneOffset();
}

export function daysIntoDateRange(
    utcStart: string,
    utcEnd: string,
    utcTarget: string,
): { totalNumberOfDays: number; daysIn: number; percentageIn: number } {
    const totalNumberOfDays = getDaysBetweenUTC(utcStart, utcEnd);

    const startTime = getTimeFromUTC(utcStart);
    const endTime = getTimeFromUTC(utcEnd);
    const targetTime = getTimeFromUTC(utcTarget);

    if (targetTime < startTime) {
        return {
            totalNumberOfDays,
            daysIn: 0,
            percentageIn: 0,
        };
    }
    if (targetTime > endTime) {
        return {
            totalNumberOfDays,
            daysIn: totalNumberOfDays,
            percentageIn: 100,
        };
    }

    const daysIn = Math.abs(getDaysBetweenUTC(utcStart, utcTarget));
    const percentageIn =
        totalNumberOfDays === 0
            ? 100
            : Math.floor((daysIn / totalNumberOfDays) * 100);

    return {
        totalNumberOfDays,
        daysIn,
        percentageIn,
    };
}

function getTimeFromUTC(utc: string): number {
    return new Date(Date.parse(utc)).getTime();
}

function getDaysBetweenUTC(utcStart: string, utcEnd: string) {
    const startTime = getTimeFromUTC(utcStart);
    const endTime = getTimeFromUTC(utcEnd);
    if (startTime > endTime) {
        throw new Error(
            'The utcStart must be less than or equal to the utcEnd',
        );
    }
    return getDaysBetweenTimestamp(startTime, endTime);
}

function getDaysBetweenTimestamp(startTime: number, endTime: number) {
    return Math.round((endTime - startTime) / (1000 * 3600 * 24));
}
